import { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { InvestigationItemContainer } from "../components/InvestigationItemContainer";
import Icon from "../../../../Icon/Icon";
import { catalogByPart } from "../../../../../apis";

// Item de la evaluacion
export const SingleEvaluation = ({
  evaluation,
  itemTitle,
  itemIcon,
  color,
  evaluationType = null,
}) => {

  const { list = [] } = evaluation;
  const lang = localStorage.getItem("lang") || "es";
  const [precautionaryMeasureOptions, setPrecautionaryMeasureOptions] = useState([]);
  const [ethicalViolationsOptions, setEthicalViolationsOptions] = useState([]);

  // Cargar las opciones del catálogo solo para actions
  useEffect(() => {
    if (evaluationType !== "actions") return;

    const loadPrecautionaryMeasureOptions = async () => {
      try {
        const response = await catalogByPart({
          is_own: true,
          catalogue: "precautionaryOrProtectiveMeasure",
          path: "/",
        });

        if (response?.data && Array.isArray(response.data)) {
          const options = response.data
            .filter(item => item.is_active)
            .map(item => ({
              label: item.locales?.[lang] || item.label,
              value: item.key,
            }));
          setPrecautionaryMeasureOptions(options);
        }
      } catch (error) {
        console.error("Error loading precautionary measure options:", error);
      }
    };

    loadPrecautionaryMeasureOptions();
  }, [evaluationType, lang]);

  // Cargar las opciones del catálogo para policies
  useEffect(() => {
    if (evaluationType !== "policies") return;

    const loadEthicalViolationsOptions = async () => {
      try {
        const response = await catalogByPart({
          is_own: true,
          catalogue: "ethicalViolations",
          path: "/",
        });

        if (response?.data && Array.isArray(response.data)) {
          const options = response.data
            .filter(item => item.is_active)
            .map(item => ({
              label: item.locales?.[lang] || item.label,
              value: item.key,
            }));
          setEthicalViolationsOptions(options);
        }
      } catch (error) {
        console.error("Error loading ethical violations options:", error);
      }
    };

    loadEthicalViolationsOptions();
  }, [evaluationType, lang]);

  // Función para obtener el label de un value del catálogo
  const getActionLabel = (value) => {
    if (evaluationType === "actions" && value) {
      const option = precautionaryMeasureOptions.find(opt => opt.value === value);
      return option?.label || value;
    }
    if (evaluationType === "policies" && value) {
      const option = ethicalViolationsOptions.find(opt => opt.value === value);
      return option?.label || value;
    }
    return value;
  };

  return (
    <InvestigationItemContainer color={color} sx={{ padding: 2 }} >
      
      <Typography fontSize={16} fontWeight={600} >
        {itemTitle}
      </Typography>

      <div className="hr-div"></div>

      <Stack spacing={1}>
        {
          list.map((item, idx)=>(
            <Box key={idx}>
              <Box key={idx} display="flex" alignItems="center">
                <Icon
                  name={itemIcon}
                  size={16}
                  color={color}
                  style={{ marginRight: 5 }}
                />
                <Typography fontSize={16} >
                  {getActionLabel(item.value)}
                </Typography>
              </Box>
              {
                !!item.details && (
                  <Typography fontSize={16} >
                    {item.details}
                  </Typography>
                )
              }
            </Box>
          ))
        }
      </Stack>

    </InvestigationItemContainer>
  )
};